const analyticsFilter1 = [
  {
    key: 1,
    label: 'Country',
    value: 'country',
  },
  {
    key: 2,
    label: 'City',
    value: 'city',
  },
  {
    key: 3,
    label: 'Hostname',
    value: 'hostname',
  },
  {
    key: 4,
    label: 'Browser',
    value: 'browser',
  },
  {
    key: 5,
    label: 'Device',
    value: 'device',
  },
  {
    key: 6,
    label: 'Agent',
    value: 'campaign',
  },
  {
    key: 7,
    label: 'OS',
    value: 'os',
  },
];

export default analyticsFilter1;
